<template>
    <section class="content">
        <!-- Default box -->
        <div class="card card-solid" :style="{ 'min-height': $store.state.screenHeight - 200 + 'px' }">
            <div class="card-body">
                <div class="card-body pt-0">
                    <div class="card-header pb-0 pl-0 pr-0">
                        <div class="row" style="margin-right:0; margin-left:0;">
                            <div class="col-sm-1 text-right pt-1">
                                <h3>ค้นหา</h3>
                            </div>
                            <div class="col-sm-6">
                                <input type="text" class="form-control" v-model="search"
                                    placeholder="กรอกเลขที่ใบกำกับภาษี เลขที่อ้างอิง หรือชื่อลูกค้า..." />
                            </div>
                            <div class="form-group row col-sm-3 pb-0">
                                <div class="col-sm-12">
                                    <button type="button" class="btn btn-success"
                                        @click="modal_active = true; doc_no = ''">
                                        <i class="fas fa-plus-circle"></i>&nbsp;ออกใบกำกับภาษี
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                    <a-modal :title="modal_title" centered v-model="modal_active" @ok="createInvoice"
                        @cancel="modal_cancel">
                        <div class="form-group row mb-1 ml-0 mr-0">
                            <label for="vendor_name" class="col-sm-1 text-right col-form-label">เลือกสาขา</label>
                            <div class="col-sm-3">
                                <select class="custom-select mr-sm-2 pb-0" id="Host" v-model="branchInsert"
                                    :disabled="isEdit">
                                    <option v-for="(bx, ix) in $store.state.branch_list" :key="'branch' + ix"
                                        :value="bx">{{ bx.branch_name }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="form-group row mb-1">
                            <label for="vendor_name" class="col-sm-1 text-right col-form-label">เลขที่อ้างอิง</label>
                            <div class="col-sm-11">
                                <!-- <textarea class="form-control" rows="3" v-model="description"></textarea> -->
                                <input type="text" class="form-control" placeholder="กรอกเลขที่ใบอ้างอิง...."
                                    v-model="doc_no" />
                                <label style="color: red" v-if="is_error">* กรุณากรอกรหัสอ้างอิง</label>
                            </div>
                        </div>
                    </a-modal>

                    <div class="text-center pt-3" v-if="report_data.length < 1">
                        <h5>ไม่มีข้อมูล</h5>
                    </div>
                    <div class="table-responsive-sm mt-3" v-if="report_data.length > 0">
                        <div class="table-responsive-sm mt-3">
                            <div>
                                <table class="table mb-0">
                                    <tbody>
                                        <tr class="thead-dark text-center trTop">
                                            <th class="text-center trTop">#</th>
                                            <th class="text-left trTop" style="width:10%">เลขที่ใบกำกับภาษี</th>
                                            <th class="text-left trTop" style="width:10%">วันที่</th>
                                            <th class="text-left trTop" style="width:30%">สาขา</th>

                                            <th class="text-left trTop" style="width:10%">เลขที่อ้างอิง</th>
                                            <th class="text-left trTop" style="width:10%">ลูกค้า</th>
                                            <th class="text-left trTop">สถานะ</th>
                                            <th class="text-center trTop" style="width:15%">
                                                ตัวเลือก
                                            </th>
                                        </tr>
                                        <tr v-for="(c, i) in paginate" :key="'c' + i">
                                            <td class="text-center">{{ i + 1 }}</td>
                                            <td class="text-left">
                                                {{ c.invoice_number }}
                                            </td>
                                            <td class="text-left">
                                                {{ c.invoice_date }}
                                            </td>
                                            <td class="text-left">
                                                {{ c.branch_name }}
                                            </td>
                                            <td class="text-left">
                                                {{ c.doc_no }}
                                            </td>
                                            <td class="text-left">
                                                {{ c.cus_name }}
                                            </td>
                                            <td class="text-left">
                                                <!-- {{ c.is_cancel ? 'ยกเลิก' : 'ใช้งาน' }} -->
                                                <label style="color: #FFC107" v-if="c.is_cancel">ยกเลิก</label>
                                                <label style="color: green" v-if="!c.is_cancel">ใช้งาน</label>
                                            </td>
                                            <td class="text-center">
                                                <button type="button" class="btn btn-warning" @click="printPDF(c)">
                                                    <i class="fas fa-edit"></i>&nbsp;พิมพ์
                                                </button>
                                                <button type="button" class="btn btn-danger"
                                                    @click="cancelInvoice(c.id)">
                                                    <i class="fas fa-trash"></i>&nbsp;ยกเลิก
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div id="components-pagination-demo-mini" class="d-flex justify-content-end"
                        v-if="report_data.length > items_perpage">
                        <a-pagination size="large" :total="report_data.length" :itemRender="itemRender"
                            @change="onChange" v-model="currentPage" />
                    </div>
                </div>
            </div>
        </div>
        <div>
            <form action="/static/pdf/tax_invoice.php" ref="printPDF" method="POST" target="_blank">
                <input type="hidden" name="data" v-model="form_data">
            </form>
        </div>
    </section>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import apiCenterV2 from "../services/service_undefined_v2";
import Swal from 'sweetalert2'
import dayjs from 'dayjs'
import buddhistEra from 'dayjs/plugin/buddhistEra';
dayjs.extend(buddhistEra);

export default {
    data() {
        return {
            tab: 0,
            report_data: [],
            startDate: moment(new Date()),
            data_edit: {},
            data_edit_pay: {},
            endDate: moment(new Date()),
            editDate: moment(new Date()),
            header: {
                headers: {
                    "Access-Token": sessionStorage.token
                }
            },
            form_data: "",
            branch: 0,
            branchId: "",
            branchName: "",
            host_list: [],
            host: null,
            data_cus_list: [],
            begin_code: "",
            end_code: "",
            dyn_address: "",
            modal_active: false,
            modal_title: "ออกใบกำกับภาษี",
            number_unit: 0.0,
            data_branch: [],
            branchInsert: 0,
            isEdit: false,
            id: "",
            stockAmount: 0.00,
            description: "",
            doc_no: "",
            is_error: false,
            currentPage: 1,
            items_perpage: 10,
            active: 1,
            search: ""
        };
    },
    computed: {
        filterData: function () {
            let text = this.search.trim();
            this.currentPage = 1;
            return this.report_data.filter(items => {
                return items.cus_name.indexOf(text) > -1 || items.invoice_number.indexOf(text) > -1 || items.doc_no.indexOf(text) > -1;
            });
        },
        paginate: function () {
            this.totalItem = this.filterData.length;
            if (this.currentPage >= this.totalPages) {
                this.currentPage = Math.max(0, this.totalPages - 1);
            }
            var index = (this.currentPage - 1) * this.items_perpage;
            return this.filterData.slice(index, index + this.items_perpage);
        }
    },
    methods: {
        onChange(pageNumber) {
            this.active = pageNumber;
        },
        createInvoice() {
            // console.log(this.branchInsert.branch_name.substring(0, 3) + "- " + this.doc_no);
            if (this.branchInsert.id != undefined && this.doc_no != "") {
                this.modal_active = false;
                this.$store.commit("Loading");
                apiCenterV2.createInvoice(
                    {
                        doc_no: this.branchInsert.branch_name.substring(0, 3) + "-" + this.doc_no,
                        branch_id: this.branchInsert.id
                    },
                    this.header,
                    results => {
                        if (results.data.status) {
                            this.getReport();
                        }
                        this.$store.commit("Loading");
                    },
                    errors => {
                        this.$store.commit("Loading");
                        this.$notification["warning"]({
                            message: "ไม่สามารถเข้าถึงข้อมูลได้",
                            description: errors.data.message
                        });
                    }
                );
            } else {
                this.is_error = true;
            }
        },
        getReport() {
            this.$store.commit("Loading");
            apiCenterV2.getInvoice(
                {
                },
                this.header,
                results => {
                    if (results.data.status && results.data.data) {
                        // this.report_data = results.data.data;
                        let data_report = results.data.data.map((e) => {
                            e.invoice_date = dayjs(e.invoice_date).format('DD/MM/BBBB HH:mm:ss');
                            return e;
                        });


                        this.report_data = data_report;

                    }
                    this.$store.commit("Loading");
                },
                errors => {
                    this.$store.commit("Loading");
                    this.$notification["warning"]({
                        message: "ไม่สามารถเข้าถึงข้อมูลได้",
                        description: errors.data.message
                    });
                }
            );

        },
        cancelInvoice(id) {
            Swal.fire({
                title: 'ลบข้อมูลสต๊อก',
                text: 'ท่านต้องการลบข้อมูลสต๊อก ใช่หรือไม่ ?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                reverseButtons: true
            }).then((result) => {
                if (result.value) {

                    apiCenterV2.cancelInvoice(
                        {
                            invoice_id: id
                        },
                        this.header,
                        results => {
                            if (results.data.status && results.data.data) {
                                this.getReport();
                            }
                            this.$store.commit("Loading");
                        },
                        errors => {
                            this.$store.commit("Loading");
                            this.$notification["warning"]({
                                message: "ไม่สามารถเข้าถึงข้อมูลได้",
                                description: errors.data.message
                            });
                        }
                    );
                }
            })
        },
        disabledDate(current) {
            // Can not select days before today and today
            return current && current.valueOf() > Date.now();
        },
        selectDateStart(current) {
            return current && current.valueOf() > this.endDate;
        },
        selectDateEnd(current) {
            return current && current.valueOf() < this.startDate;
        },
        printPDF(data) {
            data['invoice_date_pdf'] = data.invoice_date.substring(0, 10);
            this.form_data = JSON.stringify(data);
            setTimeout(() => {
                this.$refs.printPDF.submit();
            }, 1000);
        },
    },
    mounted() {
        this.getBranch();
        setTimeout(() => {
            this.branch = this.$store.state.branch_list[0];
            this.branchInsert = this.$store.state.branch_list[0];
            this.branchId = this.$store.state.branch_list[0].id;
            this.branchName = this.$store.state.branch_list[0].branch_name;
            this.dyn_address = this.$store.state.branch_list[0].dyn_address;
            this.getReport();
        }, 500);
    }
};
</script>

<style>
.trTop {
    background-color: #353a40 !important;
}

.trMid {
    color: black !important;
    background-color: #d6d6d6 !important;
}

.trBot {
    color: black !important;
    background-color: #fefac0 !important;
}

.tdtextColor {
    color: #ff2f1c !important;
}

.custom-select {
    font-size: 14px;
    height: calc(1.9rem + 2px);
}

.btn {
    font-size: 14px;
}

.justify-r {
    justify-content: right;
}

.row {
    margin-left: 0px;
    margin-right: 0px;
}

.ant-modal-body {
    padding: 24px 0px;
}

.ant-modal {
    width: 1024px !important;
    overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/tax_invoice.vue